export const COUNTERS_REQUEST_STARTED = 'counters_request_started';
export const COUNTERS_REQUEST_SUCCESS = 'counters_request_success';
export const MESSAGES_INCREMENT_COUNTER = 'messages_increment_counter';
export const CALLS_INCREMENT_COUNTER = 'calls_increment_counter';
